import { all, call, put, takeLatest } from 'redux-saga/effects';
import { decodeToken, saveAuth } from '../utils/Utils';
import { handleApiCall } from './SagaUtils';

import { LOGIN, LOGOUT } from '../constants/Constants';
import * as Api from '../services/Api';

function* login({ payload: { email, password } }) {
  yield handleApiCall(LOGIN, function* () {
    const loginRes = yield call(Api.login, email, password);
    const token = loginRes.body.access_token;
    const auth = { ...decodeToken(token), access_token: token };
    if (!auth.authorities
      || (auth.authorities.indexOf('ADMIN') === -1 && auth.authorities.indexOf('ADMIN_LOCAL') === -1)) {
      throw new Error('Unauthorized user');
    }
    const userRes = yield call(Api.fetchUser, auth.user_id, auth.access_token);
    const user = userRes.body;
    const res = { ...auth, ...user };
    saveAuth(res);
    return { body: res };
  });
}

function* logout() {
  saveAuth({});
  yield put({ type: LOGOUT.SUCCESS });
}

export default function* loginSaga() {
  yield all([
    yield takeLatest(LOGIN.REQUESTED, login),
    yield takeLatest(LOGOUT.REQUESTED, logout)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/LoginSaga.js